import { Create, Form, Input, InputNumber, Select, Switch, useForm, useSelect } from '@pankod/refine-antd';
import { IResourceComponentsProps } from '@pankod/refine-core';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { ICrate } from 'types/crate.interface';
import { IGenre } from 'types/genre.interface';
import { ILabel } from 'types/label.interface';
import { ITag } from 'types/tag.interface';
import { IUser } from 'types/user.interface';
import './styles.scss';
import { SoftOptions } from './utils';
import datetimeService from 'services/datetime.service';
import { useState } from 'react';

export const CrateCreate: React.FC<IResourceComponentsProps> = () => {
    const { formProps, saveButtonProps, formLoading } = useForm<ICrate>();
    const [bmpStart, setBmpStart] = useState<number>(0);
    const [bmpEnd, setBmpEnd] = useState<number>(0);
    const { selectProps: GenreSelectProps } = useSelect<IGenre>({
        resource: 'genres',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: TagSelectProps } = useSelect<ITag>({
        resource: 'tags',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: LabelSelectProps } = useSelect<ILabel>({
        resource: 'labels',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: UserSelectProps } = useSelect<IUser>({
        resource: 'users',
        fetchSize: 100,
        optionLabel: 'username',
        optionValue: '_id',
    });

    const { selectProps: TrackKeySelectProps } = useSelect<IUser>({
        resource: 'track-keys',
        fetchSize: 100,
        optionLabel: 'musicKey',
        optionValue: '_id',
    });

    return (
        <Create saveButtonProps={saveButtonProps} isLoading={formLoading}>
            <Form {...formProps} layout='vertical'>
                <Form.Item
                    label='Name'
                    name='name'
                    rules={[
                        {
                            required: true,
                            message: 'Name is required',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                {/* <div className="edit-title">
          <Form.Item
            className="edit-item w48"
            label="BpmFrom"
            name="bpmFrom"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            className="edit-item w48"
            label="BpmTo"
            name="bpmTo"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
        </div>
        <div className="edit-title">
          <Form.Item
            className="edit-item w48"
            label="PriceFrom"
            name="priceFrom"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            className="edit-item w48"
            label="PriceTo"
            name="priceTo"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
        </div>
        <div className="edit-title">
          <Form.Item
            className="edit-item w48"
            label="YearFrom"
            name="yearFrom"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            className="edit-item w48"
            label="YearTo"
            name="yearTo"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
        </div> */}
                <Form.Item
                    label='ShowGenres'
                    name='showGenres'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...GenreSelectProps} />
                </Form.Item>
                <Form.Item
                    label='ShowTags'
                    name='showTags'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...TagSelectProps} />
                </Form.Item>
                <Form.Item
                    label='Label'
                    name='labelId'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select {...LabelSelectProps} />
                </Form.Item>
                <Form.Item
                    label='ShowContributors'
                    name='showContributors'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...UserSelectProps} />
                </Form.Item>
                <Form.Item
                    label='ShowTrackKeys'
                    name='showTrackKeys'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select mode='multiple' {...TrackKeySelectProps} />
                </Form.Item>
                {/* <div style={{ display: "flex" }}>
          <Form.Item
            label="Clean"
            name="clean"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            label="Dirty"
            name="dirty"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox />
          </Form.Item>
        </div>
        <div style={{ display: "flex" }}>
          <Form.Item
            label="ShowAudio"
            name="showAudio"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            label="showVideo"
            name="showVideo"
            rules={[
              {
                required: false,
              },
            ]}
            style={{ width: "20%", marginRight: "10%" }}
          >
            <Checkbox />
          </Form.Item>
        </div> */}
                <Form.Item
                    label='Sort'
                    name='sort'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <Select options={SoftOptions} />
                </Form.Item>
                <div className='edit-title' style={{flexWrap: 'wrap'}}>
                    <Form.Item
                        className='edit-item w48'
                        label='BpmStart'
                        name='bpmStart'
                        rules={[
                            {
                                required: false,
                                message: 'Bpm Start is required',
                            },
                            {
                                min: 50,
                                type: 'number',
                                message: 'BPM Start must be more than 50',
                            },
                            {
                                max: 220,
                                type: 'number',
                                message: 'BPM Start must be less than BMP 220',
                            },
                            {
                                max: bmpEnd,
                                type: 'number',
                                message: 'BPM Start must be less than BMP End',
                            },
                        ]}
                    >
                        <InputNumber type='number' onChange={(value: number) => setBmpStart(value)} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='BpmEnd'
                        name='bpmEnd'
                        rules={[
                            {
                                required: false,
                            },
                            {
                                min: bmpStart + 1,
                                type: 'number',
                                message: 'BPM End must be more than BMP Start',
                            },
                            {
                                min: 50,
                                type: 'number',
                                message: 'BPM End must be more than 50',
                            },
                            {
                                max: 220,
                                type: 'number',
                                message: 'BPM End must be less than BMP 220',
                            },
                        ]}
                    >
                        <InputNumber type='number' onChange={(value: number) => setBmpEnd(value)} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='From year'
                        name='yearFrom'
                        rules={[
                            {
                                required: false,
                                message: 'Year is required',
                            },
                            {
                                min: 1950,
                                max: datetimeService.currentYear(),
                                type: 'number',
                                message: `Year must be between 1950 and ${datetimeService.currentYear()}`,
                            },
                        ]}
                    >
                        <InputNumber type='number' />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='To year'
                        name='yearTo'
                        rules={[
                            {
                                required: false,
                                message: 'Year is required',
                            },
                            {
                                min: 1950,
                                max: datetimeService.currentYear(),
                                type: 'number',
                                message: `Year must be between 1950 and ${datetimeService.currentYear()}`,
                            },
                        ]}
                    >
                        <InputNumber type='number' />
                    </Form.Item>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                    <Form.Item
                        className='edit-item w48'
                        label='Clean'
                        name='clean'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={true} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='Dirty'
                        name='dirty'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={true} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='ShowAudio'
                        name='showAudio'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={true} />
                    </Form.Item>
                    <Form.Item
                        className='edit-item w48'
                        label='ShowVideo'
                        name='showVideo'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Switch defaultChecked={true} />
                    </Form.Item>
                </div>
            </Form>
        </Create>
    );
};
